import { call, put } from "redux-saga/effects";
import { setActiveRequestsMessages, setOtherMessages, setPartRequestMessages } from "../../entities/messages";
import { requestGetSellerActiveRequestsMessages, requestGetSellerOtherMessages, requestGetPartRequestMessages, requestSendMessage } from "../requests/messages";

export function* handleGetPartRequestMessages(action) {
    try {
        const response = yield call(requestGetPartRequestMessages, action.payload);
        const { data } = response;
        yield put(setPartRequestMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetSellerActiveRequestsMessages(action) {
    try {
        const response = yield call(requestGetSellerActiveRequestsMessages, action.payload);
        const { data } = response;
        yield put(setActiveRequestsMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetSellerOtherMessages(action) {
    try {
        const response = yield call(requestGetSellerOtherMessages, action.payload);
        const { data } = response;
        yield put(setOtherMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSendMessage(action) {
    try {
        const response = yield call(requestSendMessage, action.payload);

        if (response.data) {
            const props = { partReqeustId: action.payload.part_request_id };
            const messages = yield call(requestGetPartRequestMessages, props);
            const { data } = messages;

            yield put(setPartRequestMessages({ ...data }));
        };
    } catch (error) {
        console.log(error);
    }
}
